import { css } from '@emotion/css';

export const cardPadding = css`
  padding: 13px 12px;
`;
